module.exports = ".tag {\n  background: rgba(239, 239, 239, 0.3);\n  border: 1px solid #e0e0e0;\n  width: 100px;\n  text-align: center;\n  display: inline-block;\n  position: absolute;\n  margin-top: -1px;\n  color: #252525;\n}\n.tag span {\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 0 3px;\n  position: relative;\n  top: 1px;\n}\na {\n  text-decoration: none;\n  position: relative;\n  padding-left: 120px;\n  display: block;\n  margin: 8px 0;\n}\na:hover {\n  text-decoration: underline;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_component/searchresult/searchresult.less
// module id = ./src/app/_component/searchresult/searchresult.less
// module chunks = main